import { connect } from "react-redux";
import * as Redux from "redux";
import { withRouter } from "react-router-dom";
import * as actions from "../../actions";
import * as analytics_actions from "../../../Analytics/actions";
import * as merchant_actions from "../../../Merchant/actions";
import { StoreVisits } from "../../reducer";
import { Merchant } from "../../../Merchant";
import { StoreVisitsContainer } from "./component";
import { StoreVisits as StoreVisitsConstants } from "../../constants";
import { getUserContext } from "../../../User/selectors";
import { getViewContext } from "../../selectors";
import { UserContext, ViewContext } from "../../../common/google_analytics";

export interface StoreVisitsActions {
  getPublications: (
    merchant_id: number,
    start_date: string,
    end_date: string
  ) => void;
  setPublicationSelection: (publicationIds: number[]) => void;
  removePublications: () => void;
  getMerchants: (q?: string) => void;
  setMerchantSelection: (merchant_id: number) => void;
  setStartDate: (start_date: string) => void;
  setEndDate: (end_date: string) => void;
  syncQueryString: (queryString: string) => void;
}

export interface StoreVisitsProps
  extends StoreVisits.StoreVisitsContainerState {
  merchants: Merchant[];
  publications: any[];
  publicationsLoading: boolean;
  merchantId: number;
  publicationIds: number[];
  startDate: string;
  viewContext: ViewContext;
  userContext: UserContext;
}

const mapStateToProps = (state: any, props: any): StoreVisitsProps => {
  return {
    merchants: state.merchant,
    merchantId: state.storeVisits.merchantId,
    publications: state.analytics.publications,
    publicationsLoading: state.analytics.publications_loading,
    publicationIds: state.storeVisits.publicationIds,
    startDate: state.storeVisits.startDate,
    endDate: state.storeVisits.endDate,
    viewContext: getViewContext(state),
    userContext: getUserContext(state),
    topStoresData: state.storeVisits.topStoresData
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): StoreVisitsActions => {
  return {
    ...Redux.bindActionCreators(
      {
        getPublications: analytics_actions.getPublications,
        setPublicationSelection: actions.setPublicationSelection,
        removePublications: analytics_actions.removePublications,
        getMerchants: merchant_actions.getMerchants,
        setMerchantSelection: actions.setMerchantSelection,
        setStartDate: actions.setStartDate,
        setEndDate: actions.setEndDate,
        syncQueryString: actions.syncQueryString
      },
      dispatch
    )
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StoreVisitsContainer)
);



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/components/StoreVisitsContainer/container.ts